// extracted by mini-css-extract-plugin
export var cruiseCount = "EmotionalLauncherCruiseCount-module--cruise-count--1d485";
export var cruiseCountLabel = "EmotionalLauncherCruiseCount-module--cruise-count-label--c5c74";